import { render, staticRenderFns } from "./CytologyTextPreview.vue?vue&type=template&id=33dcd075&scoped=true&"
import script from "./CytologyTextPreview.vue?vue&type=script&lang=js&"
export * from "./CytologyTextPreview.vue?vue&type=script&lang=js&"
import style0 from "./CytologyTextPreview.vue?vue&type=style&index=0&id=33dcd075&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dcd075",
  null
  
)

export default component.exports